import type { AnchorHTMLAttributes, FC } from 'react'
import classnames from 'classnames'

export interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  color?: string
  href?: string
}

export const Link: FC<LinkProps> = ({ children, color = '', href = '', className, ...props }) => (
  <a
    className={classnames(['underline font-suisse', !color ? 'text-blue-600' : color, className])}
    dir="auto"
    href={href}
    {...props}
  >
    {children}
  </a>
)
